module.exports = __webpack_public_path__ + "media/images/room_menu_icon/machine_requests-0d3f3b73e71868ef73e65ad0dbd4b492.png";